export default __webpack_public_path__ + "static/media/Ring of Yimsha.0c858afe.jpg";